import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const TextWithDiagonalImages = ({ doc }) => {
  const {
    internal_link_id,
    heading,
    subheading,
    description,
    text_cta,
    cta_link: { url: urlLink, target: urlTarget },
    text_alignment,
  } = doc?.primary || {};

  const alignClass = text_alignment ? `text-with-diagonal-${text_alignment}-align` : "";
  return (
    <div
      className={`slice-text-with-image text-with-diagonal-images-slice prismic-slice ${alignClass}`}
    >
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-absolute d-block" />
      )}
      <div className="container container-width container-2xl pt-md-5 mt-md-4 pt-xl-0 my-xl-5 pt-3 px-md-5 px-xl-5 text-with-diagonal-container-width">
        <div>
          <div className="row text-cta-section align-items-center">
            <div className="col-md-6 col-12 col-w-100">
              {checkContentPresence(heading) && (
                <div className="mb-1 mb-md-0 text-center slice-default-text slice-default-xs-text font-weight-bold text-with-diagonal-images-title">
                  {textResolver(heading)}
                </div>
              )}
            </div>
            <div className="col-md-6 col-12 col-w-100">
              {urlLink && (
                <div className="text-with-diagonal-images-cta font-weight-bold">
                  <PrismicLinkTag
                    urlText={textResolver(text_cta)}
                    url={urlLink}
                    target={urlTarget}
                  />
                </div>
              )}
            </div>
          </div>
          {checkContentPresence(subheading) && (
            <div className="mb-2 mb-md-3 text-center slice-medium-heading font-secondary font-weight-light  slice-medium-xs-heading text-with-diagonal-images-subtitle">
              {textResolver(subheading)}
            </div>
          )}
          {checkContentPresence(description) && (
            <div className="text-center slice-default-info-text mobile-fs-12 text-with-diagonal-images-description">
              {textResolver(description)}
            </div>
          )}
        </div>
      </div>
      <div className="container-fluid container-2xl mt-3 mt-md-5 bg-primary text-with-diagonal-images-assets-section">
        {doc?.items?.map(
          (
            {
              image: { url = "", alt = "" },
              title,
              description,
              align_image_to_right = false,
              text_cta: imageCtaText,
              bg_color,
              cta_link: { url: imageLinkUrl, target: imageLinkTarget },
            },
            index
          ) => {
            const imageStyle = { backgroundColor: bg_color };
            return (
              <div className="row text-center" key={index}>
                <div
                  className={`col-md-6  col-12  px-0 block-image text-with-diagonal-images-asset-block ${
                    align_image_to_right ? "order-1" : ""
                  }`}
                  style={imageStyle}
                >
                  <div className="text-with-diagonal-images-asset-holder">
                    <PrismicImgix
                      className="img-responsive img-responsive-height"
                      src={url}
                      alt={alt}
                      desktop="900px"
                      mobile="100%"
                      tablet="100%"
                      largeDisplay="100%"
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12 text-left  px-lg-7 px-sm-20 px-md-20 px-xl-7 block-info py-4 py-md-0 text-with-diagonal-images-content-block">
                  <div className="text-with-diagonal-images-content-holder">
                    {checkContentPresence(heading) && (
                      <div className="fs-30 mobile-fs-24 font-lora pb-md-2 text-with-diagonal-images-content-title">
                        {textResolver(title)}
                      </div>
                    )}
                    {checkContentPresence(description) && (
                      <div className="mt-lg-4 mt-md-3 mt-3 slice-default-info-text font-weight-light mobile-fs-16 text-with-diagonal-images-content-description">
                        {textResolver(description)}
                      </div>
                    )}
                    {imageLinkUrl && (
                      <div className="font-weight-bold text-with-diagonal-images-image-cta pt-md-4 ">
                        <PrismicLinkTag
                          urlText={textResolver(imageCtaText)}
                          url={imageLinkUrl}
                          target={imageLinkTarget}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
};

export default TextWithDiagonalImages;
